import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-autocomplete-consultant-key-lookup',
  templateUrl: './st-autocomplete-consultant-key-lookup.component.html',
  styleUrls: ['./st-autocomplete-consultant-key-lookup.component.scss'],
  standalone: false
})
export class StAutocompleteConsultantKeyLookupComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'textId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Type here';

  @Input()
  maxLength: number = 200;

  @Input()
  disabled: boolean = false;

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();

  visible: boolean = false;

  @Input()
  items: any[] = [];
  @Input()
  itemsFilter: any[] = [];

  emailKey: string = 'email';
  firstNameKey: string = 'firstName';
  lastNameKey: string = 'lastName';
  companyNameKey: string = 'companyName';

  inputData: any = {};

  multipleAllowed: boolean = false;

  constructor() {
  }

  ngOnInit(): void {

  }

  hide(): void {
    this.visible = false;
  }

  selectItem(item: any): boolean {
    let lastIndex = this.inputVal.lastIndexOf(",");
    if (lastIndex == -1 || this.inputVal.length == 0) {
      this.inputVal = item[this.emailKey];
    } else {
      let otherValues: string = this.inputVal.substring(0, lastIndex);
      this.inputVal = otherValues + ',' + item[this.emailKey];
    }
    this.visible = false;
    return true;
  }

  private fuzzySearch(lastElement: string): void {
    const delimiter: RegExp = new RegExp("[ -]");
    let lastElementArray: string[] = lastElement.split(delimiter);
    if (lastElementArray.length == 1) {
      this.itemsFilter = this.items.filter(item => item[this.emailKey].toLowerCase().includes(lastElement.toLowerCase()));
    } else if (lastElementArray.length == 2) {
      this.itemsFilter = this.items.filter(item => (item[this.emailKey].toLowerCase().includes(lastElement.toLowerCase()) ||
        (item[this.emailKey].toLowerCase().includes(lastElementArray[0].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[1].toLowerCase())
        )))
    } else if (lastElementArray.length == 3) {
      this.itemsFilter = this.items.filter(item => (item[this.emailKey].toLowerCase().includes(lastElement.toLowerCase()) ||
        (item[this.emailKey].toLowerCase().includes(lastElementArray[0].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[1].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[2].toLowerCase())
        )))
    } else if (lastElementArray.length == 4) {
      this.itemsFilter = this.items.filter(item => (item[this.emailKey].toLowerCase().includes(lastElement.toLowerCase()) ||
        (item[this.emailKey].toLowerCase().includes(lastElementArray[0].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[1].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[2].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[3].toLowerCase())
        )))
    } else {
      this.itemsFilter = this.items.filter(item => (item[this.emailKey].toLowerCase().includes(lastElement.toLowerCase()) ||
        (item[this.emailKey].toLowerCase().includes(lastElementArray[0].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[1].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[2].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[3].toLowerCase()) &&
          item[this.emailKey].toLowerCase().includes(lastElementArray[4].toLowerCase())
        )))
    }
  }

  filterData(data: any, event: KeyboardEvent) {
    this.inputVal = data;
    if (this.inputVal.length <= 1) {
      this.visible = false;
    }
    if (!this.multipleAllowed) {
      data = data.replaceAll(",", "");
      this.inputVal = data;
    }
    if(event.key === 'Escape') {
      this.visible = false;
    } else {
      this.visible = true;
    }
    let lastIndex = data.lastIndexOf(",");
    let lastElement = null;
    if (lastIndex == -1) {
      lastElement = data;
    } else {
      lastElement = data.substring(lastIndex + 1, data.length);
    }
    this.fuzzySearch(lastElement);
    //this.itemsFilter = this.items.filter( item => item[this.keyLookup].toLowerCase().includes(lastElement.toLowerCase()));
    let map = new Map(this.itemsFilter.map(i => [i[this.emailKey], i]));
    let tempArray: any = [];
    map.forEach( m => {
        tempArray.push(m)
      }
    )
    this.itemsFilter =  tempArray.slice(0,15);
  }
}
